import script from "./nextSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./nextSteps.vue?vue&type=script&setup=true&lang=js"

import "./nextSteps.vue?vue&type=style&index=0&id=762a878c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762a878c"]])

export default __exports__